import React from "react";
import { twMerge } from "tailwind-merge";

const Container = ({ children, className }) => {
  return (
    <div
      className={twMerge(
        `max-w-[1500px] mx-auto px-4 sm:px-8 md:px-14 xl:px-20 ${className}`
      )}
    >
      {children}
    </div>
  );
};

export default Container;
